module.exports = __webpack_public_path__ + "img/inf_ico.80ec210d.svg";